import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const metrics = [
  { value: "2–3x", label: "More Jobs Booked", sublabel: "month over month" },
  { value: "<5s", label: "Response Time", sublabel: "to every missed call" },
  { value: "$0", label: "Extra Staff Cost", sublabel: "AI works 24/7 for you" },
  { value: "5.0", label: "Star Reviews", sublabel: "automated collection" },
];

export default function ResultsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="results"
      data-testid="results-section"
      className="relative py-24 md:py-32 px-6 md:px-12"
      style={{ backgroundColor: "#0A0A0A" }}
    >
      <div className="max-w-7xl mx-auto" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-20"
        >
          <span
            className="inline-flex items-center gap-2 text-sm uppercase tracking-widest text-[#5B8DEF] font-medium mb-4"
            style={{ fontFamily: "Manrope, sans-serif" }}
            data-testid="results-label"
          >
            <span className="w-6 h-px bg-[#5B8DEF]"></span>
            Results
            <span className="w-6 h-px bg-[#5B8DEF]"></span>
          </span>
          <h2
            className="text-3xl md:text-4xl tracking-tight font-semibold text-white"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="results-headline"
          >
            Numbers That Speak for Themselves
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {metrics.map((metric, i) => (
            <motion.div
              key={metric.label}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.1 * (i + 1) }}
              data-testid={`metric-${i}`}
              className="text-center py-10 px-4 bg-[#121212] border border-white/[0.06] rounded-lg hover:border-white/[0.12] transition-all duration-300"
            >
              <span
                className="block text-4xl md:text-5xl font-bold text-white mb-2"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {metric.value}
              </span>
              <span
                className="block text-base font-medium text-white mb-1"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {metric.label}
              </span>
              <span
                className="block text-xs text-[#A3A3A3] uppercase tracking-wide"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                {metric.sublabel}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
